<template>
  <Card
    class="index-guide-card"
    :padding="0"
  >
    <!-- card content -->
    <div slot="title">
      <h3 class="card-title">{{ card.title }}</h3>
      <h4 class="card-subtitle">{{ card.subtitle }}</h4>
    </div>
    <div
      class="index-guide-card-thumbnail"
      :style="{backgroundImage: `url(${card.img})`}"
    />
    <div class="index-guide-card-footer text-center">
      <ButtonGroup v-if="card.type">
        <Button
          type="ghost"
          size="large"
          class="btn-default"
        >投保
          <router-link 
            :to="{ name: 'insurance', params: {type: card.type} }"
          />
        </Button>
        <Button
          type="ghost"
          size="large"
          class="btn-default"
        >介紹
          <router-link 
            :to="{ name: 'insurance', params: {type: card.type, scrollTo: 'insu-desc-wrapper'} }"
          />
        </Button>
      </ButtonGroup>
      <Button
        v-else
        disabled
        type="ghost"
        size="large"
        class="btn-default"
        v-text="'即將上線'"
      />
    </div>
    <!-- card layer -->
    <div
      slot="extra"
      class="index-guide-card-layer"
      :style="{
        backgroundImage: `
        linear-gradient(0deg,rgba(255, 108, 54, .6),
        rgba(255, 108, 54, .6)), url(${card.img})`
      }"
    >
      <h3 class="card-title">{{ card.title }}</h3>
      <h4 class="card-subtitle mb-s">{{ card.subtitle }}</h4>
      <p 
        class="fz-tiny"
        :style="{lineHeight: '1.7'}"
        v-text="card.desc"
      />
      <div class="layer-footer text-center">
        <ButtonGroup v-if="card.type">
          <Button
            type="ghost"
            size="large"
            icon="ios-calculator"
            class="btn-default"
          >投保
            <router-link 
              :to="{ name: 'insurance', params: {type: card.type} }"
            />
          </Button>
          <Button
            type="ghost"
            size="large"
            icon="android-search"
            class="btn-default"
          >介紹
            <router-link
              :to="{ name: 'insurance', params: {type: card.type, scrollTo: 'insu-desc-wrapper'} }"
            />
          </Button>
        </ButtonGroup>
        <Button
          v-else
          disabled
          type="ghost"
          size="large"
          class="btn-default"
          v-text="'即將上線'"
        />
      </div>
    </div>
  </Card> 
</template>

<script>
  import { Card, ButtonGroup, Button } from 'iview';

  export default {
    components: {
      Card,
      ButtonGroup,
      Button,
      // Icon
    },
    props: {
      card: {
        type: Object,
        default: null
      }
    }
  };
</script>
